module.exports = __webpack_public_path__ + "media/images/mobile/solutions/10-b8227f6b39b03e11c5ba1c94c9aaa579.png";